import { render, staticRenderFns } from "./ProfilDaerahMainMap.vue?vue&type=template&id=3083a7b6&scoped=true"
import script from "./ProfilDaerahMainMap.vue?vue&type=script&lang=js"
export * from "./ProfilDaerahMainMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083a7b6",
  null
  
)

export default component.exports